import { useState } from "react";
import LoginForm from "./LoginForm"
import Navbar from "./Navbar"
import LegalMenu from "./navBar/LegalMenu";

const LegalLayout = ({children, title}) => {

    const [showLoginForm, setShowLoginForm] = useState(false);

    const handleShowLoginForm = () => {
    setShowLoginForm(true);
  };

  const handleCloseLoginForm = () => {
    setShowLoginForm(false);
  };
  return (
   <>
      <Navbar
        onShowLoginForm={handleShowLoginForm}
        guestMenuHidden={true}
      />

      {showLoginForm && <LoginForm onClose={handleCloseLoginForm} />}

      <main className="main textos-legales">
        <h1 className="text-center font-semibold">{title}</h1>
        {children}
      </main>

       <LegalMenu />
   </>
  )
}

export default LegalLayout